import {Pipe, PipeTransform} from '@angular/core';
import {ChangelogItem} from '../../../@backend/modules/@documentation/models/changelog-item.model';

@Pipe({
  name: 'logItemAllDraft'
})
export class LogItemAllDraftPipe implements PipeTransform {

  transform(log: ChangelogItem[]): boolean {
    return log.filter((a) => a.status === 'DRAFT').length === log.length;
  }

}
